export enum UrlPaths {
    CARTPAGE = '/warenkorb',
    CUSTOMERDATAPAGE = '/kundeninformationen',
    CHECKDATAPAGE = '/checkout',
    ENDPAGE = '/vielen-dank',
    SELECTIONPAGE = '/produktauswahl'
}
